import React from 'react';
import LayoutAdmin from '../../layouts/admin';
import ProductManagementContent from '../../components/product_management';


const ProductManagementPage = () => {
  return (
    <LayoutAdmin content={<ProductManagementContent/>}/>
  );
}

export default ProductManagementPage;